import { Link } from 'react-router-dom';

const footerColumns = [
  {
    title: '视频分类',
    links: [
      { label: '电影', to: '/category/movie' },
      { label: '电视剧', to: '/category/tv' },
      { label: '综艺', to: '/category/variety' },
      { label: '短视频', to: '/category/short' },
    ],
  },
  {
    title: '快捷入口',
    links: [
      { label: '首页', to: '/' },
      { label: '搜索', to: '/search' },
      { label: '关于我们', to: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-foreground-950 text-background-100">
      <div className="px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-extrabold tracking-tight text-background-50">
                糖心<span className="text-primary-400">视频</span>
              </span>
            </div>
            <p className="text-sm text-background-200/80 leading-relaxed max-w-md">
              糖心视频致力于为广大视频爱好者提供电影、电视剧、综艺及短视频等多类别高清视频内容聚合体验，
              让你轻松发现并了解感兴趣的视频作品。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-100 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-100 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-100 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-background-50 mb-4">{col.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/80 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            © 2026 糖心视频 · 本站为内容聚合演示平台，所有内容均为虚构示例
          </p>
          <p className="text-xs text-background-200/60">联系邮箱：contact@tangxin-video.example</p>
        </div>
      </div>
    </footer>
  );
}